<template>
  <Typography size="secondary-sm"
              class="!font-extrabold !text-[0.9rem] text-primary text-right">
    <LiteCountDownTimer :targetDate="targetDate" @timer-end="handleTimerEnd"/>
  </Typography>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import Typography from "./common/Typography.vue"
import LiteCountDownTimer from "./lite-count-down-timer.vue";

const props = defineProps({
  endDate: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['showsidebar'])

const handleTimerEnd = () => {
  emit('timer-end')
}
const targetDate = props.endDate;
</script>
